(function () {
    // TODO: all this needs to move to its own widget / happy place...
    $(function () {

        // mm-panel-blocker for #mm_bottom_panels overlays mm-blocker
        // this prevents its default close panel click event
        // therefore we force it
        $('body').on('click', '.mm-partial-panel-close', function () {
            $('#mm-blocker').trigger('mousedown');
        });

        // Populate Nav menu if: nav button exists, nav div exists, is not a native app
        if ($('#nav_button').length && $('#mobile_nav').length && !$('body').hasClass('native-menu')) {
            // builds list of widgets during html string generation
            function buildList(list) {
                var tempString = '';
                $.each(list, function () {
                    var externalLink = this.isExternal ? ' target="_blank"' : '';
                    var icon = 'i-' + this.icon;

                    if (this.iconName) {
                      icon = 'font-icon-' + this.iconName;
                    }

                    tempString += '<li class="mobile-nav-icon ' + icon + '">' +
                        '<a href="' + this.route + '"' + externalLink + '>' + this.title + '</a>' +
                        '</li>';
                });
                return tempString;
            }

            // generates html string from requested data
            function buildHTML(data) {
                var htmlString = '';
                // User
                htmlString +=
                    '<div id="mobile_nav_user">' +
                    '<img src="' + data.navigation.user.image + '" class="user-img" height="60" width="60" alt="Profile Image" />' +
                    '<div class="user-details">' +
                    '<h3>' + data.navigation.user.name + '</h3>' +
                    '<h4>Last Login <span>' + data.navigation.user.lastLogin + '</span></h4>' +
                    '</div>' +
                    '</div>';

                // Favorites
                if (data.navigation.favoriteWidgets.length > 0) {
                    htmlString +=
                        '<div id="mobile_nav_favorites" class="mobile-nav-links">' +
                        '<h4>Favorites</h4>' +
                        '<ul>' + buildList(data.navigation.favoriteWidgets) + '</ul>' +
                        '</div>';
                }

                // More widgets
                if (data.navigation.moreWidgets.length > 0) {
                    htmlString +=
                        '<div id="mobile_nav_more" class="mobile-nav-links">' +
                        '<h4>More Widgets</h4>' +
                        '<ul>' + buildList(data.navigation.moreWidgets) + '</ul>' +
                        '</div>';
                }

                // FI
                if (data.navigation.fi.length > 0) {
                    htmlString +=
                        '<div id="mobile_nav_fi" class="mobile-nav-links">' +
                        '<h4>' + data.navigation.bankName + '</h4>' +
                        '<ul>' + buildList(data.navigation.fi) + '</ul>' +
                        '</div>';
                }

                // Footer
                // @todo - techDebt --- once we rewrite the mobile nav we can git rid of this
                // this was added per DEV-69642
                // This will take the footer from the bottom of each page and place it in
                // the bottom of the mobile_nav. If the Fi does not want this option then you
                // will need to go to that fi's views/footer.mobile and in the mobile_nav div
                // remove the  data-menufooter="true" and this will not show in the nav menu
                // also will need to go to the fi/theme/stylesheets/mobilePartials/_footer and
                // remove the code on lines 12 -14 that hide the footer throughout the application.
                var footerInfo = document.getElementById('mobile_footer');
                var mobileMenu = document.getElementById('mobile_nav');

                if (mobileMenu && mobileMenu.hasAttribute("data-menuFooter") && footerInfo) {
                    htmlString += '<div id="menu_footer">' + footerInfo.innerHTML + '</div>'
                };

                // Localization
                htmlString += '<div id="mobile_nav_language"></div>'

                // Create the nav with our constructed string.
                createNav(htmlString);
            }

            function getLocales() {
                // normally we would want to store the locales
                // to avoid a get every page load
                // but we need to clear the storage on logout
                // or some other event
                /*
                var locales = JSON.parse(localStorage.getItem('alkami.locales'));

                if (!locales) {
                    $.get('/API/Locales', function (data) {
                        createLocalesList(data);
                    }, 'json');
                } else {
                    createLocalesList(locales);
                }
                */

                $.get('/API/Locales', function (data) {
                    createLocalesList(data);
                }, 'json');
            }

            function createLocalesList(locales) {
                var localeid;
                var $mobileNavLanguage = $('#mobile_nav_language');
                var localesList;

                if (locales.length > 1) {
                    localesList = '<ul>';
                    for (var i = 0; i < locales.length; i++) {
                        localesList += '<li data-iscurrent="' + locales[i].IsCurrent + '" data-culturecode="' + locales[i].CultureCode + '" data-id="' + locales[i].Id + '">' + locales[i].Language + '</li>';
                    }
                    localesList += '</ul>';

                    $mobileNavLanguage.html(localesList);
                    $mobileNavLanguage.find('li').on('click', function () {
                        localeId = $(this).data('id');
                        $('#mobile_nav').data('mmenu').close();
                        // delay to give nav menu time to close first
                        window.setTimeout(function () {
                            alkBottomPanel('#locale_confirmation');
                        }, 400);
                    });

                    $('#confirm_locale').on('click', function() {
                        $('#locale_confirmation').addClass('confirmed');
                        saveLocaleChosen(locales, localeId)
                    });

                    $('#cancel_locale, #locale_confirmation .alk-bottom-panel-close').on('click', function () {
                        alkBottomPanel('#locale_confirmation');
                    })
                }
            }

            function saveLocaleChosen(locales, localeId) {
                // normally we would want to store the locales
                // to avoid a get every page load
                // but we need to clear the storage on logout
                // or some other event
                /*
                for (var i = 0; i < locales.length; i++) {
                    locales[i].IsCurrent = false;
                    if (locales[i].Id === localeId) {
                        locales[i].IsCurrent = true;
                    }
                }

                localStorage.setItem('alkami.locales', JSON.stringify(locales));
                */

                $.post('/API/Locales/SetLocale', { localeId: localeId })
                    .done(function (data) {
                        location.reload();
                    });
            }

            // creates nav based off generated html
            function createNav(htmlString) {
                // mobile nav is hidden by default to prevent flash of content
                // remove style attr instead of changing display to block to not override display property in CSS
                var $mobileNav = $('#mobile_nav');
                $mobileNav.removeAttr('style').mmenu().find('.mobile-nav-container').append('<div id="mobile_nav_container" tabindex="-1">' + htmlString + '</div>');

                getLocales();

                $('#nav_button').on('click', function (e) {
                    if($mobileNav.hasClass('mm-opened')) {
                        $('#mm-blocker').trigger('mousedown');
                        $('#nav_button').focus();

                        return false;
                    }
                    e.preventDefault();
                    $mobileNav.data('mmenu').open();
                    $('#mobile_nav_container').scrollTop(0).focus();

                    return false;
                });

                $mobileNav.trigger('navMenuBuilt');
            }

            // request menu data
            $.ajax({
                url: $(location).attr('protocol') + '//' + $(location).attr('host') + '/MobileClient/NavigationV2',
                dataType: 'json',
                async: true,
                success: function (data) {
                    buildHTML(data);
                }
            });
        }

        $('#full-site').click(function () {
            document.cookie = "ViewFullSite=1;path=/";
            return true;
        });

        var parser = new UAParser().getResult();
        $('body').addClass(parser.os.name.toLowerCase());

        function preventMove(e) {
            e.preventDefault();
        }

        function wrapScroller(id) {
            if (id == null || id === '')
                return;

            $('#' + id + ' .modal-content').wrap('<div id="wrap" />').wrap('<div id="scroller" />');
            var scroller = new iScroll('wrap');
        }

        function getDeviceName(ua) {
            var parser = new UAParser(ua).getResult();
            var today = new Date();
            var browsername = (parser.browser && parser.browser.name) || 'unknown';
            var osname = (parser.os && parser.os.name) || 'unknown';
            var version = (parser.browser && parser.browser.major) || '0';

            var deviceName = browsername.substring(0, 4) + ' ' + version.substring(0, 2) + ' ' + osname.substring(0, 3) + ' ' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear().toString().substring(2);
            return deviceName;
        }

        // Legacy Modals
        // WARNING: this technically only works for a single modal on a page - we're not unwrapping/unbinding scroll when user closes modal yet
        $('.modal').each(function () {
            var modalId = this.id,
                a = $('a[href="#' + modalId + '"]');

            if (!modalId) {
                return;
            }

            a.click(function () {
                if (!$('#wrap').length) {
                    if (modalId == 'transfer_policy') {
                        $('#transfer_policy .modal-content').load('/Content/Disclosures/Show?name=DisclosureTransfer', function () {
                            wrapScroller(modalId);
                        });
                    } else {
                        wrapScroller(modalId);
                    }

                    $('#' + modalId).trigger("modalOpened");
                }
                setTimeout(function () {
                    document.addEventListener('touchmove', preventMove, false);
                }, 500);
            });
        });

        $('a[href="#close"]').click(function () {
            document.removeEventListener('touchmove', preventMove);
        });

        /* Remember Device */
        $('#DeviceName').val(getDeviceName());
    });

    bindCurrencyFields();
})();

// Some backwards compatible black magic that needs cleaning up.
(function () {
    var $infoPanel = $('#mm_panel_info');
    var $infoPanelFooter = $('#mm_panel_info .footer');
    var $pageFooterInfo = $('#mobile_info_panel');

    if ($infoPanel.length > 0 && $infoPanelFooter.length > 0 && $pageFooterInfo.length > 0) {
        $infoPanel.attr('tabindex', -1);
        $infoPanelFooter.html($pageFooterInfo.html());

        // Find all focusable elements in the info panel. 
        var focusableElements = $infoPanel.find('a[href]:not([disabled]), button:not([disabled])');
        var firstFocusableElement = focusableElements[0];
        var lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Listen for tab or shift tab keypress and apply logic if the first or last element had focus
        $infoPanel.on('keydown', function(e) {
            var isTabPressed = e.key === 'Tab';

            if (!isTabPressed) { 
                return; 
            }

            if ( e.shiftKey ) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });
    }
})();


//New Mobile Menu -- Horizontal Scroller w/ snap to grid for active item 10.7.16
$(function () {
    var options = {
        class: {
            active: 'active'
        },
        dom: {
            menuItem: 'a.tab',
            menu: '.tab-wrapper',
            parent: '.tab-nav',
            menuNext: '#tab-next',
            menuPrevious: '#tab-previous'
        }
    };

    // main function for switching active menu item
    function menuGoNumber(number) {
        var that = $(options.dom.menu).find(options.dom.menuItem + ':nth-child(' + number + ')');
        var newLeft = 0;
        var parent = $(options.dom.parent);
        var scrolled = $(options.dom.parent).scrollLeft();
        if (that.length > 0) {
            // highlight active element
            $('.' + options.class.active).removeClass(options.class.active);
            that.addClass(options.class.active);
            // scroll cycle menu to active element
            newLeft = (parent.width() * 0.5) - that.position().left - (that.width() * 0.5) + scrolled - 10;
            $(options.dom.menu).animate({ left: newLeft }, 500, 'swing');
            return true;
        }
        return false;
    }

    // helper function for previouse item
    function menuGoPrevious() {
        // find active
        var that = $(options.dom.menu).find(options.dom.menuItem + '.' + options.class.active);
        if (that.index() > 0) {
            menuGoNumber(that.index() + 1 - 1);
            return true;
        }
        return false;
    }

    // helper function for next item
    function menuGoNext() {
        // find active
        var that = $(options.dom.menu).find(options.dom.menuItem + '.' + options.class.active);
        var menuLength = $(options.dom.menu).find(options.dom.menuItem).length;
        if (that.index() < menuLength - 1) {
            menuGoNumber(that.index() + 1 + 1);
            return true;
        }
        return false;
    }

    // helper function to refresh view
    function menuGoRefresh() {
        // find active
        var that = $(options.dom.menu).find(options.dom.menuItem + '.' + options.class.active);
        menuGoNumber(that.index() + 1);
    }


    // --------------------------------------------------
    // do stuff
    // --------------------------------------------------

    // bind resize
    $(window).on('resize', function () {
        menuGoRefresh();
    });

    // bind click on menu items
    $(options.dom.menuItem).on('click', function () {
        var that = $(this);
        menuGoNumber(that.index() + 1);
    });

    // bind click on next and previous button
    $(options.dom.menuNext).on('click', menuGoNext);
    $(options.dom.menuPrevious).on('click', menuGoPrevious);

    // start with first menu item
    menuGoNumber(1);

});
